import { get, filter } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectServiceRequests = state => searchEntities(state, 'serviceRequests', ['ticketId', 'reporterName', 'status', 'serviceType','itemName', 'propertyName','ticketNumber']);

export const selectServiceRequestById = (state, id) => filter(selectServiceRequests(state), s => s.id === id)[0];

export const selectServiceRequestDocuments = (state, id) => get(selectServiceRequestById(state, id), ['documents'], []);

export const selectServiceRequestNotes = (state, id) => get(selectServiceRequestById(state, id), ['notes'], []);
